export default "__VITE_ASSET__ClTEhWbx__"